import React from 'react';
import { Link } from 'react-router-dom';

function Newsletter() {
  return (
    <div className="worker-banner-outer">
      <div className="container">
        <div className="worker-banner-inner">
          <div className="worker-banner-content">
            <h3>Are you a skilled worker?</h3>
            <p>Join our community of professionals and start getting hired today.</p>
          </div>
          <div className="worker-banner-action">
            <Link className="worker-banner-btn" to="/talent/register">
              Register now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Newsletter;
